export default __webpack_public_path__ + "static/mercedes-685e0219cc8f4b45f5c8e1bf153113f8.png";